import styled from 'styled-components'

export const ConditionsContainer = styled.div`
  margin-top: ${props => props.theme.whiteLabel.spacing.sp16};
  margin-bottom: ${props => props.theme.whiteLabel.spacing.sp24};
  display: flex;
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`
